@if (loader$ | async) {
  <div class="loader-wrapper">
    <span class="loader">
      <mat-spinner diameter="64"></mat-spinner>
    </span>
  </div>
}
<router-outlet></router-outlet>